import { render, staticRenderFns } from "./messgaeName.vue?vue&type=template&id=5278ecb9"
import script from "./messgaeName.vue?vue&type=script&lang=js"
export * from "./messgaeName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports